import { Button } from '@components/button';
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@components/form/form';
import { Input } from '@components/form/input';
import { PermissionGroups } from '@components/permissionGroups';
import { useCreateAcquirerUserForm } from '@hooks/forms/acquirerUsers/createForm';
import { useGetPermissionGroups } from '@services/acquirer/users/permissionGroups';
import { useTranslation } from 'react-i18next';

export function CreateAcquirerUserForm({
  formObj,
}: {
  formObj: ReturnType<typeof useCreateAcquirerUserForm>;
}) {
  const { t } = useTranslation('app');
  const { data: permissions } = useGetPermissionGroups();
  const { form, onSubmit, error, isPending } = formObj;

  if (!permissions) return null;

  return (
    <Form {...form}>
      <form
        id="userForm"
        className="flex flex-col gap-4"
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel required>{t('form.name.label')}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel required>{t('form.email.label')}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="description"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('form.description.label')}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormLabel className="static ml-3 mt-2">{t('form.permissions.label')}</FormLabel>
        <FormField
          control={form.control}
          name="permissions"
          render={({ field }) => (
            <PermissionGroups
              permissions={permissions}
              selectedValues={field.value}
              onSelect={(perms: string[]) => form.setValue('permissions', perms)}
            />
          )}
        />
        {error && <p className="text-red">{error}</p>}

        <Button type="submit" variant="primary" disabled={isPending} loading={isPending}>
          {t('form.submit.userCreate')}
        </Button>
      </form>
    </Form>
  );
}
